import { toPercentageString, toStringSmartly } from '@common/Common';
import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { guid } from '@common/Guid';
import Navigation from '@common/Navigation.vue';
import { ICommandBase } from '@Quest/cqrs';
import { CapexItemEditorFormSubmitEventPayload, CapexItemEditorViewModel } from '@Quest/Financials/Capex/Components/CapexItemEditor';
import CapexItemEditor from '@Quest/Financials/Capex/Components/CapexItemEditor.vue';
import { DepreciationMethodType } from '@Quest/Financials/types';
import ProjectNavigation from '@Quest/Projects/Components/ProjectNavigation.vue';
import { CreateProjectCapexItemCommandV1, DeleteProjectCapexItemCommandV1, UpdateProjectCapexItemCommandV1 } from '@Quest/Projects/Domain/commands-core';
import ProjectsCommands from '@Quest/Projects/Domain/commands-vue-component';
import ProjectsQueries from '@Quest/Projects/Domain/queries-vue-component';
import { ProjectCapexItemReadModel, ProjectPlanCapexReadModel } from '@Quest/Projects/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: {
        PortfolioNavigation, ProjectNavigation, Navigation, CapexItemEditor
    }
})
export default class ProjectCapexPage extends mixins(ProjectsQueries, ProjectsCommands)
{
    get workspaceId(): number  { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
    get projectId(): string { return this.$route.params.projectId; }

    get portfolioId(): string { return this.rm!.PortfolioId; }
    get isWorkspaceMember(): boolean { return this.rm?.IsWorkspaceMember ?? false }
    get isProjectOwner(): boolean { return this.rm?.IsProjectOwner ?? false }
    get isSubmitted(): boolean { return this.rm!.IsSubmitted; }

    rm: ProjectPlanCapexReadModel | null = null;

    capexItemEditor: CapexItemEditorViewModel = new CapexItemEditorViewModel(); 

    fmtNum(val: number | null) { return toStringSmartly(val); }

    fmtPct(val: number | null) { return toPercentageString(val); }

    showCapexCreator()
    {
        this.capexItemEditor.showCreator(this.rm.CurrencyLabel, this.rm.CapexAccounts);
    }

    showCapexEditor(c: ProjectCapexItemReadModel)
    {
        this.capexItemEditor.showEditor(c.Id, c.Name, c.CapexAccountId, c.Cost, c.UsefulLifeInYears, c.AcquisitionMonthIndex, c.SalvageValue, this.rm.CurrencyLabel, this.rm.CapexAccounts);
    }

    handleCapexItemEditorFormSubmit(e: CapexItemEditorFormSubmitEventPayload)
    {
        if (e.id == null)
        {
            this.invokeCreateProjectCapexItemCommandV1(this.workspaceId, this.portfolioId, this.projectId, this.rm!.ActivePlanId, this.rm!.ProjectPlanId,
                e.accountId, guid(), e.name, e.cost, e.acquisitionMonthIndex, e.salvageValue, e.usefulLifeInYears, DepreciationMethodType.StraightLine, this.rm!.Denomination);
        }
        else
        {
            this.invokeUpdateProjectCapexItemCommandV1(this.workspaceId, this.portfolioId, this.projectId, this.rm!.ActivePlanId, this.rm!.ProjectPlanId,
                e.accountId, e.id, e.name, e.cost, e.acquisitionMonthIndex, e.salvageValue, e.usefulLifeInYears, DepreciationMethodType.StraightLine, this.rm!.Denomination);
        }
    }


    handleDeleteProjectCapexItemCommand(capex: ProjectCapexItemReadModel)
    {
        if (confirm("Are you sure?") === true)
        {
            this.invokeDeleteProjectCapexItemCommandV1(this.workspaceId, this.portfolioId, this.projectId, this.rm!.ActivePlanId, this.rm!.ProjectPlanId, capex.Id);
        }
    }

    mounted()
    {
        document.title = "Capex | TransparentChoice";
        this.runProjectCapexQueryV1(this.workspaceId, this.tchProjectId, this.projectId, this.$route.params.planId ?? null);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "ProjectPlanCapexReadModel")
        {
            this.rm = model as ProjectPlanCapexReadModel;
            this.capexItemEditor.close();
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreateProjectCapexItemCommandV1.matchType(cmd))
        {
            this.runProjectCapexQueryV1(this.workspaceId, this.tchProjectId, this.projectId, this.rm!.ProjectPlanId);
        }
        else if (DeleteProjectCapexItemCommandV1.matchType(cmd))
        {
            this.runProjectCapexQueryV1(this.workspaceId, this.tchProjectId, this.projectId, this.rm!.ProjectPlanId);
        }
        else if (UpdateProjectCapexItemCommandV1.matchType(cmd))
        {
            this.runProjectCapexQueryV1(this.workspaceId, this.tchProjectId, this.projectId, this.rm!.ProjectPlanId);
        }
    }
}